module.exports = "<div id=\"desktopsearch--goButton\" class=\"desktopSearch--goButton\">\n    <i class=\"fa fa-arrow-right\"></i>\n</div>\n<input id=\"searchData\" type=\"text\" name=\"firstname\" autofocus=\"autofocus\" value=\"\" class=\"desktopSearch--FieldContainer\">"


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/searchField/searchField.component.html
// module id = ../../../../../src/app/components/searchField/searchField.component.html
// module chunks = main